import Enum from './enum'

class Target extends Enum {
    static DISTRIBUTOR = 1;
    static SCHOOL = 2;

    static values() {
        return {
            [this.DISTRIBUTOR]: '販売店',
            [this.SCHOOL]: '学校',
        }
    }
}

export default Target;
